import React from 'react';

import Card from '../Assets/Card.png';
import Bank from '../Assets/Bank.png';
import Insurance from '../Assets/Insurance.png';
import Wallet from '../Assets/wallet.png';

const FintechRocketSection = () => {
  return (
    <section
      className="relative bg-white py-20 px-4 sm:px-8 lg:px-20 w-full overflow-hidden"
      id="fintech"
    >
      {/* Content Wrapper */}
      <div className="max-w-7xl mx-auto">
        {/* Title */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold mb-8 text-left">
          FinTech Industries We Serve
        </h2>

        {/* Subtext */}
        <p className="text-base sm:text-lg md:text-xl mb-16 text-left font-normal text-neutral-700">
          We combine strategy, technology, data science and design to solve the most complex business challenges
        </p>

        {/* Industry Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-12 gap-x-12">
          {[
            {
              img: Wallet,
              title: 'Wealth Management',
              desc: 'Robo Advisory, KYC, Digital Distribution, Risk & Reporting, etc.',
            },
            {
              img: Bank,
              title: 'Asset Management',
              desc: 'Portfolio Mgmt, Compliance, Risk Analytics, etc.',
            },
            {
              img: Card,
              title: 'Payments',
              desc: 'BNPL, POS, Partner Ecosystems, SWIFT, ISO Standards 20022',
            },
            {
              img: Insurance,
              title: 'Insurance',
              desc: 'P2P, AI-based Chatbot, Automated Claims, etc.',
            },
          ].map(({ img, title, desc }) => (
            <div key={title} className="flex flex-col items-start gap-4">
              <img src={img} className="w-12 h-auto" alt={title} />
              <h3 className="text-lg sm:text-xl md:text-2xl font-semibold">{title}</h3>
              <p className="text-base sm:text-lg md:text-xl font-normal text-neutral-700">{desc}</p>
            </div>
          ))}
        </div>

        {/* Services Section */}
        <div className="mt-24">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold mb-16 text-left">
            Our Services →
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-16 gap-x-12">
            {[
              {
                title: 'Data & Technology Consultation',
                desc: 'Data Analytics, AI/ML, BI, Cloud',
              },
              {
                title: 'Product & Business Consultation',
                desc: 'UX/UI, Product Development, Digital Marketing',
              },
            ].map(({ title, desc }) => (
              <div key={title} className="flex flex-col gap-4 items-start">
                <h4 className="text-lg sm:text-xl md:text-2xl font-semibold">{title}</h4>
                <p className="text-base sm:text-lg md:text-xl text-neutral-600">{desc}</p>
                <button className="w-fit bg-black text-white text-base sm:text-lg px-6 py-3 mt-6 hover:bg-neutral-900 transition">
                  Know more
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FintechRocketSection;
